import React, { useEffect, useState } from 'react';
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { useSession } from "next-auth/react";
import { IconBookmark, IconCheck } from "@tabler/icons-react";
import { fetchApi } from '@/lib/utils';

const EmissionSubscribe = ({ nid, mini = false }) => {

  const [isSub, setIsSub] = useState<boolean>();

  const { data, update, status } = useSession()

  const { toast } = useToast()

  useEffect(() => {
    const podcasts = data?.user?.podcasts;

    if (podcasts !== undefined) {
      const find = podcasts?.find((element) => element === nid)

      if (find !== undefined) {
        setIsSub(true)
      }
    }

  }, [data, status])

  const handleClick = async (e) => {
    e.preventDefault()

    let podcasts = data?.user?.podcasts;

    if (podcasts === undefined) {
      podcasts = [];
    }
    console.log(podcasts);

    const values = isSub ? podcasts.filter((element) => element !== nid) : [...podcasts || [], nid];

    try {
      const response = await fetchApi(`/api/user-subscriptions`, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${data?.accessToken}`
        },
        body: JSON.stringify({ podcasts: values })
      });
      if (!response.ok && response.success === false) {
        throw new Error("Network response was not ok");
      }
      await update({ podcasts: values });
      setIsSub(!isSub);
      toast({ title: isSub ? "Emission supprimée" : "Emission enregistrée" })
    } catch (e) {
      toast({
        description: 'Erreur lors de l\'envoi du formulaire'
      })
    }
  }

  return (
    <>
      {status === "authenticated" && (
        <Button onClick={handleClick} size={mini ? "icon" : "default"} variant={"tertiary"} iconLeft={isSub ? <IconCheck size={20} /> : <IconBookmark size={20} />}>
          {!mini && (
            <>
              {isSub ? (
                <>Suivi</>
              ) : (
                <>S&apos;abonner</>
              )}
            </>
          )}
        </Button>
      )}
    </>
  );
};

export default EmissionSubscribe;